import React from "react";

function Header({ title }) {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const companyName = userData.ComName || "Company";

  const headerStyle = {
    background: "#2c3e50",
    color: "#fff",
    padding: "16px 40px",
    fontWeight: 600,
    letterSpacing: "1px",
    fontSize: "16px",
    position: "relative",
    zIndex: 1002,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  };

  const userInfoStyle = {
    display: "flex",
    alignItems: "center",
    gap: "16px"
  };

  const userDetailsStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px"
  };

  const logoutBtnStyle = {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  return (
    <div style={headerStyle}>
      <span>{companyName}</span>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <div style={{ fontSize: "14px", opacity: 0.8 }}>{title}</div>
        <div style={userInfoStyle}>
          <div style={userDetailsStyle}>
            <span style={{ fontSize: "18px" }}>👤</span>
            <span>{userData.Usrname || "User"}</span>
          </div>
          <button 
            onClick={() => {
              localStorage.removeItem("userData");
              window.location.href = "/";
            }}
            style={logoutBtnStyle}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Header;